<ion-content class="template-container">
  <div
    style="height: 100%; display: flex; flex-direction: column"
    *ngIf="template"
  >
    <ion-toolbar>
      <div style="display: flex">
        <ion-title>
          <a
            style="font-size: 1rem; margin-right: 14px"
            (click)="checkIfShouldGoBack()"
          >
            <ion-icon name="chevron-back-outline"></ion-icon>
          </a>
          <span class="template-top-title" (click)="editTemplate()">{{
            template.name
          }}</span>
          <a
            style="font-size: 1rem; margin-left: 14px"
            (click)="editTemplate()"
            [hidden]="isReadOnly"
          >
            <ion-icon name="create-outline"></ion-icon>
          </a>
        </ion-title>
        <div style="margin: 10px">
          <ion-button
            color="warning"
            shape="round"
            (click)="showWarnings()"
            [hidden]="!warning || isReadOnly"
            class="action-button"
            *ngIf="!isReadOnly"
          >
            <ion-icon name="warning-outline"></ion-icon>
            1
          </ion-button>
          <ion-button
            [color]="template.id ? 'light' : 'success'"
            (click)="save()"
            [disabled]="isLoading"
            class="action-button"
          >
            <ion-icon
              name="checkmark-outline"
              *ngIf="!template.id"
              class="padded-icon"
            ></ion-icon>
            Save
          </ion-button>
          <ion-button
            [color]="isReadOnly ? 'success' : 'light'"
            (click)="clone()"
            [disabled]="isLoading"
            class="action-button"
            *ngIf="template.id"
          >
            <ion-icon
              name="duplicate-outline"
              *ngIf="isReadOnly"
              class="padded-icon"
            ></ion-icon>
            Save as...
          </ion-button>
          <span *ngIf="!isReadOnly">
            <ion-button
              (click)="sendEmail()"
              [disabled]="isLoading"
              *ngIf="template.id && template.type === 'email'"
              class="action-button"
            >
              <ion-icon
                name="mail-outline"
                class="padded-icon"
                [hidden]="isFetchingMembers"
              ></ion-icon>
              <ion-spinner
                name="crescent"
                style="margin-right: 10px"
                [hidden]="!isFetchingMembers"
              ></ion-spinner>
              Compose
            </ion-button>
            <ion-button
              (click)="sendSlack()"
              [disabled]="isLoading"
              *ngIf="template.id && template.type === 'slack'"
              class="action-button"
            >
              <ion-icon
                name="logo-slack"
                class="padded-icon"
                [hidden]="isFetchingMembers"
              ></ion-icon>
              <ion-spinner
                name="crescent"
                style="margin-right: 10px"
                [hidden]="!isFetchingMembers"
              ></ion-spinner>
              Compose
            </ion-button>
          </span>
        </div>
      </div>
    </ion-toolbar>

    <app-unlayer-wrapper
      style="height: 100%"
      (loaded)="editorLoaded()"
      [hidden]="!template || template.type !== 'email'"
      [options]="unlayerOptions()"
    >
    </app-unlayer-wrapper>
    <app-slack-blocks
      [blocks]="blocks"
      [communityId]="communityId"
      [project]="template.project"
      *ngIf="template && template.type === 'slack'"
    >
    </app-slack-blocks>
  </div>
</ion-content>
